import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useApiContext } from 'react-easyrocket';
import { GPTGameNameType } from 'src/EXPERIMENTAL_LIB/gpt/games';
import { GAMES_CONFIG } from 'src/EXPERIMENTAL_LIB/gpt/games/config';
import {
  CACHE_TIME_2000,
  HTTP_NO_CONTENT,
  HTTP_OK
} from 'src/EXPERIMENTAL_LIB/gpt/games/constants';
import { getQueryStatus } from 'src/EXPERIMENTAL_LIB/gpt/games/utils/getQueryStatus';

export const useCheckGPTGameStatus = ({
  gameName,
  enabled = true
}: {
  gameName: GPTGameNameType;
  enabled?: boolean;
}) => {
  const { isAuthenticated } = useApiContext();
  const { statusUrl, statusUrlNonAuth } = GAMES_CONFIG[gameName];
  const url = !isAuthenticated ? statusUrlNonAuth : statusUrl;

  const { data, error, isLoading, refetch } = useQuery<AxiosResponse<''>, AxiosError>({
    queryKey: [url],
    queryFn: () =>
      axios.request<''>({
        method: 'get',
        url: window.origin + '/api' + url
      }),
    enabled: Boolean(url) && enabled,
    ...CACHE_TIME_2000
  });

  const status = getQueryStatus(data, error);
  const isAvailable = !isLoading && (status === HTTP_NO_CONTENT || status === HTTP_OK);
  return { isAvailable, isLoading, refetch };
};
